// Chakra imports
import { ChakraProvider, Flex } from "@chakra-ui/react";
import BgSignUp from "assets/img/BgSignUp.png";
import FooterHome from "components/Footer/FooterHome.js";
import React, { useContext } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import routes from "routes.js";
// Custom Chakra theme
import theme from "theme/theme.js";
// Custom components
import MainPanel from "components/Layout/MainPanel";
import PanelContainer from "components/Layout/PanelContainer";
import PanelContent from "components/Layout/PanelContent";
import Header from "components/Header/Header";

export default function Dashboard(props) {
  const { ...rest } = props;
  // functions for changing the states from components


  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === "/") {
        return (
          <Route
            path={prop.path}
            component={prop.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };

  // Chakra Color Mode
  return (
    <ChakraProvider theme={theme} resetCss={false}>
      <Header />
      <MainPanel
        w={{
          base: "100%"
        }}
        h={{
            base: "100%"
          }}
      >
        <PanelContent paddingTop={{base: "80px"}}>
          <PanelContainer>
            <Switch>
            {getRoutes(routes)}
            </Switch>
          </PanelContainer>
        </PanelContent>
        <FooterHome />
      </MainPanel>
    </ChakraProvider>
  );
}
